<template>
    <Header></Header>
    <div class="LocationBar"><div class="inner"><ul class="Location"><li class="Location__item home"><a href="" class="Location__item--btn"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAABPklEQVQ4ja3TP0sDQRAF8J+HiGAKLQVFsbIQ4p/SRrDKB0hhZyXYiFjnQ9jZCJYigo2CRUDBNkr8ArGytRAUooVaZALHceeZ4IOFtzPz3s4uOyP1el0JFnAafAtPvxUnJWZ1tPEYqx2xQowWxMdxGB3t4CziNzjGJvbR/UuHi2hhDaspM8FXI9eK2l8Nt3GPJtbRyTmwE7lm1G6nk/0rV3CEmt41L3OM0vjEAW5xovcEu3hLsIwHzAcvM0vjMjTz4bGcROvn2MDzAGZ9PIf2HM0EM2jgAtUhDKuhbWB2FB+RmMNUjmAEK8Hb+M7kp0IL3aJ/2McErjOGNbwXCcomZVfvB0zHqkSsEGUdLuEKb7G/ilghyjqErwI+tOFA+HfD7BtWMJnaj+VoxjI1lSLDV/ljt5fiL3qzvpWpueuTH1quOlOE3j3aAAAAAElFTkSuQmCC" alt="이미지"></a></li><li class="Location__item"><a href="javascript:;" class="Location__item--btn"><p>진료과/의료진</p><span></span></a><div class="Location__item--Layer"><ul><li><a href="/hospital/department-doctor/department.do" class="">진료과/의료진</a></li><li><a href="/reserve/appointment.do" class="">예약/발급</a></li><li><a href="/hospital/information/outpatient.do" class="">이용안내</a></li><li><a href="/hospital/healthInfo/consulting.do" class="">건강정보</a></li><li><a href="/hospital/hospitalIntro/fatima/greetings.do" class="">병원소개</a></li></ul></div></li><li class="Location__item"><a href="javascript:;" class="Location__item--btn"><p>센터 & 클리닉</p><span></span></a><div class="Location__item--Layer"><ul><li><a href="/hospital/hospitalIntro/fatima/greetings.do" class="">창원파티마병원</a></li><li><a href="/hospital/hospitalIntro/story/newsBoard.do" class="">파티마이야기</a></li><li><a href="/hospital/hospitalIntro/active/prayBoard.do" class="">병원활동</a></li></ul></div></li><li class="Location__item"><div class="Location__item--Layer"><ul><li><a aria-current="page" href="/kr/news/list.do" class="router-link-active router-link-exact-active">화이팅</a></li><li><a href="/kr/press/list.do" class="">언론보도</a></li><li><a href="/kr/event/list.do" class="">행사안내</a></li><li><a href="/kr/job/list.do" class="">퍼블팀</a></li><li><a href="https://fliphtml5.com/bookcase/nrkwy/" to="https://fliphtml5.com/bookcase/nrkwy/">파티마 웹진</a></li><li><a href="/kr/gallery/list.do" class=""></a></li></ul></div></li></ul></div></div>
    <div class="container">
        <div class="sub-tit">
            <h2>클리닉</h2>
        </div>
        <div class="inner">
            <div class="board__search">
        <div class="board__input">
            <input type="text" placeholder="검색어를 입력해주세요.">
            <button type="button" class="board__input-btn"></button>
        </div>
    </div>

    <div class="tab-menu type02">
        <ul class="tab-menu__list">
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">전체</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">구강</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">귀코목</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">내분비</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">뇌신경</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">눈</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">면역</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">비뇨기</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">뼈근육</button>
            </li>
        </ul>
        <ul class="tab-menu__list">
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">생식기</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">소화기</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">순환기</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">암</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">정신건강</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">피부</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">호흡기</button>
            </li>
            <li class="tab-menu__item">
                <button type="button" class="tab-menu__btn">기타</button>
            </li>
        </ul>
    </div>
    <ul class="contents masonry">
        <!-- <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>1 </h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>2 </h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>3 </h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>4 </h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>5 </h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>6 </h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>7 </h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>8 </h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>9 </h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>10 </h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>11</h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>12</h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>13</h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>14</h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>15</h4>
                    
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>15</h4>
                    
                </div>
            </a>
        </li>
         -->
         <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__img">
                    <img src="@/assets/resource/img/kv_bg01.png" alt="이미지">
                </div>
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__img">
                    <img src="@/assets/resource/img/kv_bg01.png" alt="이미지">
                </div>
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__img">
                    <img src="@/assets/resource/img/kv_bg01.png" alt="이미지">
                </div>
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__img">
                    <img src="@/assets/resource/img/kv_bg01.png" alt="이미지">
                </div>
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>
        <li class="masonry__item">
            <a href="javascript:;" class="masonry__link">
                <div class="masonry__text">
                    <h4>상처관리와 흉터예방 상처관리와 흉터예방</h4>
                    <p class="desc">피부가 자외선을 받게 되면 비교적 짧은짧은짧은짧은</p>
                    <div class="arrow-wrap">
                        <span class="tag">#약물처치</span>
                        <div class="arrow-btn"></div>
                    </div>
                </div>
            </a>
        </li>

    </ul>
        </div>
    </div>
    <Footer></Footer>
</template>
<style>
    /* @import url('../../assets/resource/css/sub.css'); */
</style>


<script>
import Header from '@/components/common/Header.vue';
import LocationBar from '@/components/common/LocationBar.vue';
import Footer from '@/components/common/Footer.vue';
export default {
    components: {
        Header,
        LocationBar,
        Footer
    },
    data() {
        return {
            itemLength: 0,
            itemWidth: 0,
            itemMargin: ''
        };
    },
    mounted() {
        this.updateMasonryLayout();
        window.addEventListener('resize', this.updateMasonryLayout);
        const masonryItems = document.querySelectorAll('.masonry__item');
        masonryItems.forEach(item => {
            item.addEventListener('mouseenter', this.handleMouseEnter);
            item.addEventListener('mouseleave', this.handleMouseLeave);
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateMasonryLayout);
        const masonryItems = document.querySelectorAll('.masonry__item');
        masonryItems.forEach(item => {
            item.removeEventListener('mouseenter', this.handleMouseEnter);
            item.removeEventListener('mouseleave', this.handleMouseLeave);
        });
    },
    methods: {
        updateMasonryLayout() {
            if (window.innerWidth >= 1440) {
                // PC
                this.itemLength = 4;
                this.itemWidth = 25;
                this.itemMargin = '20px';
            } else if (window.innerWidth >= 721) {
                // 테블릿
                this.itemLength = 2;
                this.itemWidth = 49;
                this.itemMargin = '10px';
            } else {
                // 모바일
                this.itemLength = 1;
                this.itemWidth = 100;
                this.itemMargin = '10px';
            }
            this.setupMasonryLayout();
        },
        handleMouseEnter(event) {
            this.setupMasonryLayout();
        },
        handleMouseLeave(event) {
            this.setupMasonryLayout();
        },
        setupMasonryLayout() {
            const masonryItems = document.querySelectorAll('.masonry__item');
            let columnHeights = Array.from({ length: this.itemLength }, () => 0);

            masonryItems.forEach(item => {
                const minHeight = Math.min(...columnHeights);
                const columnIndex = columnHeights.indexOf(minHeight);
                item.style.marginBottom = this.itemMargin;
                item.style.position = 'absolute';
                item.style.left = `${columnIndex * this.itemWidth}%`;
                item.style.top = `${columnHeights[columnIndex]}px`;
                columnHeights[columnIndex] += item.offsetHeight + parseInt(this.itemMargin);
            });

            const maxHeight = Math.max(...columnHeights);
            document.querySelector('.masonry').style.height = `${maxHeight}px`;
        }
    }
};
</script>